import { reactive, ref } from 'vue';

const model = reactive({
	code: null,
	taxNumber: null,
	name: null,
	contactPerson: null,
	email: null,
	analiticsFormat: null,
	frequency: null,
	phoneNumber: null,
	privacyPolicyAccepted: null,
	dataChangeAccepted: null,
	captchaKey: null,
	captchaText: null
});

const captchaError = ref(false);

export const useStore = () => {
	return { model, captchaError };
};
